import { KeyboardArrowDown } from '@mui/icons-material';
import { Button, Menu, MenuItem } from '@mui/material';
import { GridRowSelectionModel } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import { exportAccountingRecords } from 'src/shared/services/paymentService';
import { toast } from 'react-toastify';
import React from 'react';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { AccountingRecord } from '../models/accountingRecord';

type PaymentExportButtonProps = {
  selectionModel: GridRowSelectionModel;
  rows: AccountingRecord[];
  ownerId: number;
};

export const PaymentExportButton = (props: PaymentExportButtonProps) => {
  const { rows, selectionModel, ownerId } = props;
  const { t } = useTranslation(['invoice']);

  const isMounted = useIsMounted();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const exportByFormat = async (format: string) => {
    handleClose();
    const selectedIDs = Array.from(new Set(selectionModel));
    const items = rows.filter((x) => selectedIDs.includes(x.id)).map((x) => x.verificationNo);

    const fetchData = async () => {
      try {
        await exportAccountingRecords(format, items, ownerId);
        if (isMounted()) toast.success(<>{t('invoice:export.exportInitialized')}</>);
      } catch (e) {
        if (isMounted()) ConsoleHelper.log(e);
      }
    };
    fetchData();
  };

  return (
    <>
      <Button
        variant='contained'
        id='payment-export-button'
        disableElevation
        endIcon={<KeyboardArrowDown fontSize='small' />}
        aria-controls={open ? 'payment-export-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        {t('invoice:payment.paymentExportButton')}
      </Button>
      <Menu
        id='payment-export-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'payment-export-button',
        }}
      >
        <MenuItem onClick={() => exportByFormat('SIE')}>{t('invoice:payment.exportFormat.SIE')}</MenuItem>
        <MenuItem onClick={() => exportByFormat('XLSX')}>{t('invoice:payment.exportFormat.Excel')}</MenuItem>
      </Menu>
    </>
  );
};
